import comp from "./ConfigureAIVoiceV2";
export default comp;
